module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"届出及び遮断","already_blocked":"すでに届出及び遮断した掲示物です。","cancel":"キャンセル","submit":"届出","error":"届出の受付に失敗しました。入力値をご確認ください。"}}')
  delete Component.options._Ctor
}
